import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "./primitives.js";
export const PatientCareWorkStatusSchema = z.enum([
    "waiting",
    "planned",
    "waiting_for_dependency",
    "partially_received",
    "review_required",
    "communication_pending",
    "acknowledgement_required",
    "follow_up_required",
    "overdue",
    "completed",
    "cancelled",
    "cannot_complete",
]);
const NullableId = IdSchema.nullable();
const NullableDate = IsoDateTimeSchema.nullable();
export const PatientCareWorkItemSchema = z.object({
    id: IdSchema,
    kind: z.enum(["lab", "imaging", "referral", "follow_up", "other"]),
    title: z.string(),
    status: PatientCareWorkStatusSchema,
    nextAction: z.string(),
    primaryExpectedEventId: IdSchema,
    expectedEventIds: z.array(IdSchema).min(1),
    sourceActionId: IdSchema,
    encounterId: IdSchema,
    ownerId: IdSchema,
    ownerName: z.string().nullable(),
    backupOwnerId: NullableId,
    backupOwnerName: z.string().nullable(),
    timing: z.object({
        expectedBy: NullableDate,
        overdueAt: NullableDate,
        plannedAt: NullableDate,
        nextFollowUpAt: NullableDate,
        snoozedUntil: NullableDate,
        waitingForDependency: z.boolean(),
    }),
    requestedTests: z.array(z.string()),
    receivedTests: z.array(z.string()),
    remainingTests: z.array(z.string()),
    receivedReportIds: z.array(IdSchema),
    receivedReports: z.array(z.object({
        id: IdSchema,
        title: z.string(),
        reviewStatus: z.string(),
        communicationRequired: z.boolean(),
        communicationRecorded: z.boolean(),
    })),
    members: z
        .array(z.object({
        expectedEventId: IdSchema,
        eventType: z.string(),
        status: z.string(),
        title: z.string(),
        sourceActionId: IdSchema,
        ownerId: IdSchema,
        ownerName: z.string().nullable(),
        expectedBy: NullableDate,
    }))
        .min(1),
    navigation: z.object({
        trackingAvailable: z.boolean(),
        encounterId: IdSchema,
        expectedEventId: IdSchema,
        reportId: NullableId,
        referralId: NullableId,
        taskId: NullableId,
    }),
});
export const PatientCareWorkSchema = z.object({
    patientId: IdSchema,
    siteId: IdSchema,
    items: z.array(PatientCareWorkItemSchema).max(100),
    total: z.number().int().nonnegative(),
    hasMore: z.boolean(),
    completedItems: z.array(PatientCareWorkItemSchema).max(20),
    completedTotal: z.number().int().nonnegative(),
});
//# sourceMappingURL=patient-care-work.js.map